import { getValue } from './utilities';

function parseItemData(slide) {
  const value = getValue(slide, 'value');
  const label = getValue(slide, 'label', true);

  return {
    value,
    label,
  };
}

const ROOT_KEY = 'key-facts';
const FACT_KEY = 'fact';
let COMPONENT_INDEX = 0;

export default class KeyFactsComponent {
  init() {
    jQuery(ROOT_KEY).each((i, el) => {
      this.render(el);
    });

    return this;
  }

  /**
   * Renders the History Slider
   * @param {HTMLElement} root
   */
  render(root) {
    COMPONENT_INDEX = 1 + COMPONENT_INDEX;
    const xml = root.outerHTML;
    const title = root.getAttribute('title');
    const asAtDate = root.getAttribute('as-at-date');
    const classes = root.getAttribute('class');
    const dom = jQuery(
      `<div class="key-facts${classes ? ' ' + classes : ''}" id="key-facts--${COMPONENT_INDEX}">
         ${title ? `<h3 class="key-facts__title">${title}</h3>` : ''}
         <div class="key-facts__content"></div>
         ${
           asAtDate
             ? '<div class="key-facts__as-at-date">' + Drupal.t('As at @date', { '@date': asAtDate }) + '</div>'
             : ''
         }
       </div>`,
    );

    const row = dom.find('.key-facts__content');

    jQuery(xml)
      .children(FACT_KEY)
      .each((j, fact) => {
        const data = parseItemData(fact);
        const labels = Object.values(data.label);
        let text = '';

        labels.forEach((label) => {
          text += `<div class="key-facts__body">${label}</div>`;
        });

        row.append(`
          <div class="key-facts__column">
            <div class="key-facts__header">${data.value}</div>
            <div class="key-facts__fact">${text}</div>
          </div>
        `);
      });

    jQuery(root).replaceWith(dom);
  }
}
